// extracted by mini-css-extract-plugin
export var drawerContent = "_3h-0";
export var valueBlock = "_3h-1";
export var valueBlockFrom = "_3h-2 _3h-1";
export var valueBlockTo = "_3h-3 _3h-1";